import { render, staticRenderFns } from "./Legislacion.vue?vue&type=template&id=3f49fa8d"
import script from "./Legislacion.vue?vue&type=script&lang=js"
export * from "./Legislacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports